// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"57d2cae1","208":"9d423ed6","293":"3fd45101","516":"3e7a0bc5","917":"609a5b12","946":"b278a346"}[chunkId] + ".chunk.js";
};